import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

export interface CommunService {
  new: boolean
  stockUpdate: boolean
  update: boolean
  obj: any
  index: number
}
@Injectable()
export class OrdersCommunicationService {
  constructor() {}

  private emitChangeSource = new Subject<Partial<CommunService>>()

  changeEmitted$ = this.emitChangeSource.asObservable()

  emitChange(data: Partial<CommunService>) {
    this.emitChangeSource.next(data)
  }
}
